import { Box, Checkbox, ListItemIcon, ListItemText, Typography } from "@material-ui/core";
import React, { FC, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  listItemText: {
    display: 'flex',
    alignItems: 'center'
  },
  checkbox: {
    padding: '0 16px'
  },
  listItemIcon: {
    minWidth: '0'
  },
  statusIncomplete: {
    maxHeight: '26px',
    background: '#313c49',
    border: '1px solid #37414e',
    borderRadius: '4px',
    padding: '2px 7px'
  },
  statusCompleted: {
    maxHeight: '26px',
    background: '#558b84',
    border: '1px solid #66b9a5',
    borderRadius: '4px',
    padding: '2px 7px'
  },
  cellName: {
    width: '54%',
    display: 'flex',
    flexDirection: 'row'
  },
  cellUser: {
    width: '12%',
    display: 'flex',
    justifyContent: 'center'
  },
  cellStatus: {
    width: '12%',
    minWidth: '100px',
    padding: '0 10px',
    display: 'flex',
    justifyContent: 'center'
  },
  cellLastUpdate: {
    width: '12%',
    padding: '0 10px',
    textAlign: 'center'
  },
  cellMandatory: {
    width: '10%',
    minWidth: '94px',
    display: 'flex',
    justifyContent: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%'
  },
})

type PropsType = {
  id: string,
  index: number
  title: string,
  isDone: boolean,
  isMandatory: boolean,
  updatedBy: string,
  updatedAt: string,
  onUpdateChecklist: (id: string, index: number) => void
}

const ChecklistAccordionSummary: FC<PropsType> = ({
  id,
  index,
  title,
  isDone,
  isMandatory,
  updatedBy,
  updatedAt,
  onUpdateChecklist
}) => {
  const classes = useStyles()
  const {t, i18n} = useTranslation()

  const getUser = (status: boolean, userId: string | null) => {
    let user: string | null = ''
    if (userId) user = userId
    return <Typography style={{textAlign: 'center'}}>{user}</Typography>
  }

  const getStatusCompeted = (status: boolean) => {
    const statusData = {
      class: classes.statusIncomplete,
      textKey: 'CLP_incomplete'
    }

    if (status) {
      statusData.class = classes.statusCompleted
      statusData.textKey ='CLP_completed'
    }

    return (
      <Box className={statusData.class}>
        <Typography>{t(statusData.textKey)}</Typography>
      </Box>
    )
  }

  const getMandatory = (mandatory: boolean) => {
    let content: string | null = ''
    if (mandatory) {
      content = t('CLP_Mandatory')
    }
    return <Typography>{content}</Typography>
  }

  const getDate = (date: string | null) => {
    if (!date) {
      return '-'
    }
    return new Date(updatedAt).toLocaleDateString(
      i18n.language,
      {
        year: 'numeric',
        month: '2-digit',
        day: "2-digit"
      }
    )
  }

  return (
    <div className={classes.row}>
      <Box className={classes.cellName}>
        <ListItemIcon className={classes.listItemIcon}>
          <Checkbox
            style={{color: isDone ? 'rgba(122, 231, 199, 1)' : 'rgba(218, 218, 218, 1)'}}
            className={classes.checkbox}
            edge="start"
            checked={isDone}
            tabIndex={-1}
            disableRipple
            onClick={(e) => {
              e.stopPropagation()
              onUpdateChecklist(id, index)
            }}
            inputProps={{ "aria-labelledby": id }}
          />
        </ListItemIcon>
        <ListItemText
          className={classes.listItemText}
          id={id}
          primary={title}
        />
      </Box>
      <Box className={classes.cellMandatory}>
        {getMandatory(isMandatory)}
      </Box>
      <Box className={classes.cellUser}>
        {getUser(isDone, updatedBy)}
      </Box>
      <Box className={classes.cellStatus}>
        {getStatusCompeted(isDone)}
      </Box>
      <Box className={classes.cellLastUpdate}>
        {getDate(updatedAt)}
      </Box>
    </div>
  )
}

export default ChecklistAccordionSummary
